import { useDocumentsDictionary } from '@/shared/api/queries/useDocumentsDictionary';
import {
  Loader,
  ModalComponentWrapper,
  UserProfileAction,
} from '@/shared/components';
import { useTranslation } from 'react-i18next';
import DocumentIcon from '@/shared/assets/document-icon.svg?react';

type Props = {
  onBack: () => void;
};

export function LegalStatementsModal({ onBack }: Props) {
  const { t } = useTranslation();

  const { documentsData, isDocumentsLoading, documentsError } =
    useDocumentsDictionary();

  if (isDocumentsLoading || !documentsData) {
    return <Loader />;
  }

  if (documentsError) {
    return <div>Error</div>;
  }

  return (
    <ModalComponentWrapper
      title={t('personalAccount.userProfile.legalStatements.title')}
      onBack={onBack}>
      <div className="py-2 px-0 rounded-[1.6rem] w-full shadow-none flex flex-col gap-2">
        {documentsData.value.map((docObj, index) => {
          const [name, url] = Object.entries(docObj)[0];

          return (
            <UserProfileAction
              key={`${name}-${index}`}
              showChevron={false}
              icon={<DocumentIcon className="size-10 text-primary" />}
              title={name}
              onClick={() => window.open(url, '_blank')}
            />
          );
        })}
      </div>
    </ModalComponentWrapper>
  );
}
